<template>
    <!-- notify me form -->
    <div id="notify-me-form">
        <div v-if="notifyMeFormSubmitted" class="formsent">
            <i class="icongiant-check"></i> {{getInterfaceText('form_sent_successfully')}}
        </div>
        <div v-else>
            <p class="when-available-text" v-html="getInterfaceText('shop_notifywhenavailable_text')"></p>
            <form id="notify-me-form" v-if="!notifyMeFormSubmitted && showNotifyMe == true" v-on:submit="submitNotifyMeForm($event)">
                <div class="form-group clearfix">
                    <div class="wrapper-floating-label" :class="{ 'movelabel' : notifyMeForm.email != null && notifyMeForm.email != '', 'active' : emailHasFocus }">
                        <label for="Email" style="top:0.4rem;">{{getInterfaceText('email')}}</label>
                        <input class="form-control" style="border-radius: 4px;" id="Email" name="Email" type="email" v-model="notifyMeForm.email" v-on:focus="setFocusToEmail(true)" v-on:blur="setFocusToEmail(false)">
                    </div>
                </div>
                <div class="form-group clearfix">
                    <div class="wrapper-floating-label first-child" :class="{ 'movelabel' : notifyMeForm.zipcode != null && notifyMeForm.zipcode != '', 'active' : zipcodeHasFocus }">
                        <label for="Zipcode" style="top:0.4rem;">{{getInterfaceText('form_zipcode')}}</label>
                        <input class="form-control" style="border-radius: 4px; width: 100px;" id="Zipcode" name="Zipcode" type="text" v-model="notifyMeForm.zipcode" v-on:focus="setFocusToZipcode(true)" v-on:blur="setFocusToZipcode(false)">
                    </div>
                </div>
                <div class="form-group form-group-combined form-group-combined-first-smaller clearfix">
                    <div id="availability-updates-optin" class="first-child">
                        <input type="checkbox" v-model="notifyMeForm.checkStockAlertOptin" required id="checkStockAlertOptin" style="height: 12px; margin: 0 10px 18px 0" />
                        <label for="checkStockAlertOptin" v-html="getInterfaceText('stockalertoptin')"></label>
                    </div>
                    <div class="input-group input-group-floating-label-style">
                        <button type="submit" class="btn btn-select">{{getInterfaceText('send')}}</button>
                    </div>
                </div>
                <p class="errormessage" v-if="errorMessage">{{ errorMessage }}</p>
            </form>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import vueStore from '../store/store.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'NotifyMe',
        props: ['partnumberCode'],
        mixins: [generalMixin],
        data: function () {
            return {
                notifyMeForm: {
                    partnumberCode: '',
                    email: '',
                    zipcode: ''
                },
                showNotifyMeForm: false,
                showNotifyMe: true,
                notifyMeFormSubmitted: false,
                emailHasFocus: false,
                zipcodeHasFocus: false,
                errorMessage: ""
            }
        },
        methods: {
            toggleNotifyMeForm() {
                this.showNotifyMeForm = !this.showNotifyMeForm;
            },
            submitNotifyMeForm(event) {
                var that = this;
                // prevent
                event.preventDefault();
                // define url
                var apiUrl = window.masterDomain + '/' + window.culture + '/shop/stockalert';
                // add partnumber
                this.notifyMeForm.partnumberCode = this.partnumberCode;
                //get coordinates
                this.getCoordinatesByAddress(function (clientlocation) {
                    that.notifyMeForm.latitude = clientlocation.geometry.location.lat();
                    that.notifyMeForm.longitude = clientlocation.geometry.location.lng();

                    // send to api
                    axios.post(apiUrl, that.notifyMeForm)
                        .then(function (response) {
                            if (response.data == "True") {
                                that.notifyMeFormSubmitted = true;
                            } else {
                                that.errorMessage = response.data;
                            }
                        });
                });

                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'notify_me', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name });
            },
            setFocusToEmail(isFocus) {
                this.emailHasFocus = isFocus;
            },
            setFocusToZipcode(isFocus) {
                this.zipcodeHasFocus = isFocus;
            },
            getCoordinatesByAddress(callback) {
                var that = this;
                var geocoder = new window.google.maps.Geocoder();
                geocoder.geocode({ 'address': this.notifyMeForm.zipcode }, function (results, status) {

                    if (status == window.google.maps.GeocoderStatus.OK) {
                        if (callback) {
                            console.log(results);
                            callback(results[0]);
                        }
                    } else {
                        that.errorMessage = 'Zipcode not found';
                    }
                });
            },
        },
        computed: {
            product() {
                return vueStore.state.product
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
            this.showNotifyMe = document.getElementById('vue-parameters').dataset.shownotifyme == 'true';
        }
    }
</script>
